import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-191edcb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photovoltaic-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-container" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "光储充监控大屏")
], -1))
const _hoisted_3 = { class: "photovoltaic" }
const _hoisted_4 = { class: "left-container" }
const _hoisted_5 = { class: "station-status" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "设备运行状态", -1))
const _hoisted_7 = { class: "station-status-chart" }
const _hoisted_8 = { class: "station-status-ratio" }
const _hoisted_9 = { class: "energy-growth-trend" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "设备运行趋势", -1))
const _hoisted_11 = { class: "energy-growth-trend-chart" }
const _hoisted_12 = { class: "site-ranking" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "站点排名", -1))
const _hoisted_14 = { class: "site-ranking-chart" }
const _hoisted_15 = { class: "center-container" }
const _hoisted_16 = { class: "right-container" }
const _hoisted_17 = { class: "energy-conversion" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "能量转换", -1))
const _hoisted_19 = { class: "energy-conversion-info" }
const _hoisted_20 = { class: "energy-analysis" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "今日能量分析", -1))
const _hoisted_22 = { class: "energy-analysis-line-chart" }
const _hoisted_23 = { class: "energy-analysis" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "月度能量分析", -1))
const _hoisted_25 = { class: "energy-analysis-bar-chart" }

import StationStatusChartPie from './components/StationStatusChartPie.vue'
import StationStatusRadioChartPie from './components/StationStatusRadioChartPie.vue'
import EnergyGrowthTrendChartLine from './components/EnergyGrowthTrendChartLine.vue'
import EnergyAnalysisChartBar from './components/EnergyAnalysisChartBar.vue'
import EnergyAnalysisChartLine from './components/EnergyAnalysisChartLine.vue'
import EnergyConversionInfo from './components/EnergyConversionInfo.vue'
import StationChartMap from './components/StationChartMap.vue'
import AutoSwitchTabList from './components/AutoSwitchTabList.vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { usePhotovoltaicData } from './usePhotovoltaicData'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  deviceMonitorStatsChartData,
  deviceMonitorStats,
  essEnergyGrowthTrendChartData,
  stationRankList,
  stationGeoStats,
  essEnergyConversionStats,
  essEnergyAnalysisStatsChartData,
  essEnergyAnalysisStatsMonthChartData,
} = usePhotovoltaicData()

const timer = ref(new Date())
let intervalId: number | undefined
const updateTimer = () => {
  timer.value = new Date()
}

const formatDate = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}
onMounted(() => {
  // initStationOverviewData()
  intervalId = window.setInterval(updateTimer, 1000)
})

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createVNode(StationStatusChartPie, { data: _unref(deviceMonitorStatsChartData) }, null, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createVNode(StationStatusRadioChartPie, {
                  name: "设备在线率",
                  value: _unref(deviceMonitorStats).onlineRate
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(StationStatusRadioChartPie, {
                  name: "设备告警率",
                  value: _unref(deviceMonitorStats).alarmRate
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(EnergyGrowthTrendChartLine, { data: _unref(essEnergyGrowthTrendChartData) }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(AutoSwitchTabList, {
              tabs: _unref(stationRankList),
              switchInterval: 3000
            }, null, 8, ["tabs"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(StationChartMap, { data: _unref(stationGeoStats) }, null, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(EnergyConversionInfo, { data: _unref(essEnergyConversionStats) }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createVNode(EnergyAnalysisChartLine, { data: _unref(essEnergyAnalysisStatsChartData) }, null, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(EnergyAnalysisChartBar, { data: _unref(essEnergyAnalysisStatsMonthChartData) }, null, 8, ["data"])
          ])
        ])
      ])
    ])
  ]))
}
}

})